/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconNumber2 = createReactComponent("outline", "number-2", "IconNumber2", [["path", { "d": "M8 8a4 4 0 1 1 8 0c0 1.098 -.564 2.025 -1.159 2.815l-6.841 9.185h8", "key": "svg-0" }]]);

export { IconNumber2 as default };
//# sourceMappingURL=IconNumber2.mjs.map
